import { toMillis } from '../contracts/billingApi';

// Renewal / expiry dates, formatted once for the whole billing surface.
//
// Two lengths on purpose. The /membership status page has a full column to
// itself and reads better long ("August 16, 2026"); the Account card puts the
// date inside a one-line detail row beside a price, where the long month wraps
// on a phone. Same source value, same null handling, one place to change it.
//
// Returns null — never a placeholder string — so callers decide what an absent
// date means. A "—" here would render as a date that says nothing.
export default function formatMembershipDate(value, { long = false } = {}) {
  const ms = toMillis(value);
  if (ms == null) return null;
  return new Date(ms).toLocaleDateString(undefined, {
    year: 'numeric',
    month: long ? 'long' : 'short',
    day: 'numeric',
  });
}

// Month and year only, for "MEMBER SINCE". A join date is an era, not an
// appointment — the day adds a digit nobody reads.
//
// Takes a Firebase Auth `metadata.creationTime` (an RFC-1123 string), not an
// entitlement field: the account predates the subscription, and on /membership
// this row is the one that says so.
export function formatMemberSince(creationTime) {
  if (!creationTime) return null;
  const date = new Date(creationTime);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}
